import { TableActionType, ColumnsTypes } from '../types';

import { DropDown } from '@wajeez-web/components/ui';
import { DotsHorizontalIcon } from '@heroicons/react/outline';
import { HasPermissionWrapperComponent } from '@wajeez-web/components/helpers';
import { HasPermission } from '@wajeez-web/components/helpers';
const columnHandler = (
  columns: ColumnsTypes[],
  tableActions: (id: string, row: any) => TableActionType[] = () => []
): any => {
  const getActions = (): any => {
    if (tableActions.length) {
      return [
        {
          width: '70px',
          id: 'action',
          right: false,
          name: '',
          allowOverflow: true,
          style: {
            position: 'sticky',
            left: 0,
            boxShadow: '1px 0 5px -2px #888',
            background: 'white',
            zIndex: 1,
            borderRight: '1px soild #000',
          },
          cell: (row: any, rowIndex: any) => {
            return (
              <HasPermissionWrapperComponent
                permissions={tableActions(row[1], row).map(
                  (item: { permission: any }) => item.permission
                )}
              >
                <DropDown
                  name="actions"
                  key={rowIndex}
                  Icon={DotsHorizontalIcon}
                  list={
                    tableActions(row[1], row)
                      ?.filter((ele) => HasPermission(ele.permission))
                      .map((item) => {
                        switch (item.type) {
                          case 'request':
                            return {
                              label: item.title,
                              type: 'action',
                              onClick: () => {
                                item.action && item.action();
                              },
                            };
                          case 'link':
                            return {
                              label: item.title,
                              type: 'link',
                              link: item.endpoint.replace(':id', row['1']),
                              // eslint-disable-next-line @typescript-eslint/no-empty-function
                              onClick: () => {},
                            };
                          default:
                            return {
                              type: 'action',
                              label: item.title,
                              // eslint-disable-next-line @typescript-eslint/no-empty-function
                              onClick: () => {},
                            };
                        }
                      }) || []
                  }
                />
              </HasPermissionWrapperComponent>
            );
          },
        },
      ];
    } else return [];
  };
  return [...getActions()].concat([
    ...columns.filter((ele) => {
      return ele.id !== 1 && !ele.isHidden;
    }),
  ]);
};

export default columnHandler;
